import React, { useState } from "react";
import { toast } from "react-toastify";
import { Select, Input, Textarea } from "../../../components/form";
import { Button } from "../../../components/button";
import { StockExitReason } from "../../../__generated__/globalTypes";
import { useExitStockUnit } from "../hooks";
import { stockExitReasonLabel } from "../../../helpers/enum-labels";

interface IProps {
  stockUnitId: number;
  onCompleted: () => void;
}

export const ExitStockUnitForm: React.FC<IProps> = ({
  stockUnitId,
  onCompleted,
}) => {
  const { exit, loading } = useExitStockUnit();
  const [exitReason, setExitReason] = useState<StockExitReason | "">("");
  const [issueComment, setIssueComment] = useState("");
  const [orderId, setOrderId] = useState("");

  const handleSubmit = async () => {
    if (!exitReason) return;

    if (exitReason === StockExitReason.Sold && !orderId) {
      toast.error("Une commande est requise pour une sortie vendue");
      return;
    }
    if (exitReason === StockExitReason.Issue && !issueComment.trim()) {
      toast.error("Un commentaire est requis pour une sortie incident");
      return;
    }

    const ok = await exit({
      id: stockUnitId,
      exitReason,
      issueComment: issueComment.trim() || undefined,
      orderId: orderId ? +orderId : undefined,
    });

    if (ok) {
      toast.success("Le lot a été sorti du stock");
      onCompleted();
    }
  };

  return (
    <div className="flex flex-wrap gap-3 items-end">
      <Select
        label="Motif de sortie"
        className="w-full"
        value={exitReason}
        onChange={(e) => setExitReason(e.target.value as StockExitReason)}
      >
        <option value="">-</option>
        {Object.keys(StockExitReason).map((reason) => (
          <option key={reason} value={reason}>
            {stockExitReasonLabel(reason)}
          </option>
        ))}
      </Select>
      {exitReason === StockExitReason.Sold && (
        <Input
          label="ID de la commande"
          type="number"
          className="w-full"
          value={orderId}
          onChange={(e) => setOrderId(e.target.value)}
        />
      )}
      {exitReason === StockExitReason.Issue && (
        <Textarea
          label="Commentaire"
          className="w-full"
          value={issueComment}
          onChange={(e) => setIssueComment(e.target.value)}
        />
      )}
      <Button onClick={handleSubmit} loading={loading} disabled={loading || !exitReason}>
        Sortir du stock
      </Button>
    </div>
  );
};
